<template>
    <div :class="classObj">
        <h1>{{title}}</h1>

        <collapsible-card class="mt-3" :is-tabbed="tabbed">
            <h4 
                slot="header">
                You must have this information
            </h4>
            <span 
                slot="body">
                <p>When making a claim please ensure that you have the following information available to you as you will require it to complete the online claim form.</p>
                <ul>
                    <li>Your Policy Number</li>
                    <li>Full circumstances of your claim</li>
                    <li>Copies of the relevant documentation (see below)</li>
                </ul>
            </span>
        </collapsible-card>

        <collapsible-card class="mt-3" :is-tabbed="tabbed">
            <h4 
                slot="header">
                What documentation do I need to provide?
            </h4>
            <span slot="body">
                <p>We may ask you to provide one or more of the following to help us process your claim.</p>
                <h5>Proof of Ownership</h5>
                <p>You must provide evidence to show that you own the gadget such as:
                    <ul>
                        <li>Original Purchase invoice<small class="text-muted">*</small></li>
                        <li>Contract Agreement from Network Provider (devices with SIM cards)<small class="text-muted">**</small></li>
                    </ul>
                    <small class="text-muted">*  If your gadget was purchased second hand, or gifted to you, please refer to the gadget definition within your policy wording or contact our support team to confirm the policy requirements.</small><br/>
                    <small class="text-muted">** The document must include the make, model and IMEI (in respect of mobile phones) or serial number together with the date of purchase of the device.</small>
                </p>
                <h5>Proof of Usage (SIM enabled devices)</h5>
                <p>You must request confirmation of dates of usage for the gadget from your network provider. The proof of usage document should include the device make and model, IMEI number and confirm the date when the device was first and last used.</p>

                <h5>Photographs of the Damage</h5>
                <p>Please provide photographs of your gadget (front/back and each side).  These should be taken using another phone/camera. Please ensure that a front image is provided ensuring that the IMEI is visible on the screen of your device.  To display the IMEI dial *#06#.  Please also provide an image of each side and the back of your device.</p>
                <p>What is an IMEI number?
                    <ul>
                        <li>The IMEI number is unique to your handset and you can find this by typing *#06# in to your handsets key pad.</li>
                    </ul>

                </p>
            </span>
        </collapsible-card>

        <collapsible-card class="mt-3" :is-tabbed="tabbed">
            <h4 slot="header">Do I need to pay an excess?</h4>
            <span slot="body" v-html="excessCardBody"></span>
        </collapsible-card>

        <collapsible-card class="mt-3" :is-tabbed="tabbed">
            <h4 slot="header">How long will it take to receive a decision?</h4>
            <span slot="body"><p>We will assess your claim and aim to approve it within 2 working days of receiving all requested documentation.</p></span>
        </collapsible-card>

        <collapsible-card class="mt-3" :is-tabbed="tabbed">
            <h4 slot="header">How long will the repair take?</h4>
            <span slot="body"><p>Our repair centre will aim to repair your gadget within 72 hours or receiving your device. Once your claim is approved, we will contact you to advise on where to send your device for repair.</p></span>
        </collapsible-card>

        <collapsible-card class="mt-3" :is-tabbed="tabbed">
            <h4 slot="header">What if my gadget needs to be replaced?</h4>
            <span slot="body">
                <p>If your gadget is deemed beyond economical repair and will need to be replaced, we will endeavour to replace it with an identical fully refurbished or new (where a refurbished item is not available) item. 
                    Should this not be possible we will replace it with a fully refurbished or new (where a refurbished item is not available) item of a identical specification or the equivalent value.</p>
                <p><strong>Please note:</strong> it may not always be possible to replace your gadget with the same colour or finish, where this is not possible an alternative colour will be provided.</p>
            </span>
        </collapsible-card>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import CollapsibleCard from '@/components/CollapsibleCard.vue'
export default {    
    components: {
        CollapsibleCard
    },
    props: {
        tabbed: {
            type: Boolean,
            default: false,
            notes: 'Used to pass prop to collapsible card component'
        },
        title: {
            type: String,
            default: 'Making a gadget claim...'
        }
    },
    computed: {
        classObj() {
            let klass = {};
            this.tabbed ? (klass["greyerbox"] = true) : (klass["greybox"] = true);

            return klass;
        },
        ...mapGetters({
            getMasterInfo: 'reseller/getMasterInfo',
            getReseller: 'reseller/getResellerInfo',      
        }),
        excessCardBody() {
            const defaultExcess = '<p>A policy excess must be paid by you in respect of each and every valid claim for each and every gadget being claimed for under each incident.  ' + 
                'The policy excess amount is dependent on your chosen level of cover, the value of the gadget and the type of claim made.  ' +
                'Please refer to your Policy Schedule and the Terms and Conditions of your Policy document to confirm which excess amount is applicable.</p>'

            try {
                if (this.getReseller.guide.excess && this.getReseller.guide.excess != '') {
                    return this.getReseller.guide.excess
                }
            }
            catch { /* Do nothing*/ }

            return defaultExcess
        }
    }
}
</script>

